<script setup lang="ts">
/**
 * UI-kit component
 * Category: Logos
 * Name: 'AppLogoDomain'
 * FIGMA: 'https://www.figma.com/design/n8yjfgcFUgYPq4BLYjeYcJ/Design-System--Client?node-id=4087-114535&m=dev'
 */
import { Logo } from '@brighterly/lib-lumee-ui'

import type { AppLogoDomainProps } from '@UI/Logos/AppLogoDomain/types/interfaces'

import { useAppLogoDomain } from '@UI/Logos/AppLogoDomain/composables/use-app-logo-domain.hook'

defineOptions({
  name: 'AppLogoDomain',
})

withDefaults(defineProps<AppLogoDomainProps>(), {
  type: 'full',
  color: 'main',
  size: 'md',
})

const { logoBrand } = useAppLogoDomain()
</script>

<template>
  <Logo
    :brand="logoBrand"
    :type="type"
    :color="color"
    :size="size"
  />
</template>
